import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { PageHeader } from '../../../../utils/models/page-header';
import { FinYear } from '../../models/finyear';
import { FinYearService } from '../../services/finyear.service';
import { CoreSaveService, UtilsService, MessageService, ICommonMessage, FieldType, ConfigService } from '@gbs-platform-client/fwk-core'
import { NotificationsService } from '@gbs-platform-client/building-blocks';
import { APIResponse } from 'src/app/utils/models/response';
import { takeUntil } from 'rxjs/operators';
import { forkJoin, Subject } from 'rxjs';
import { ExcelExportComponent } from '@progress/kendo-angular-excel-export';
import { CompanyService } from '../../services/company.service';
import { Company } from '../../models/company';
import { DatePipe } from '@angular/common';
import { DateService } from '../../services/date.service';

import { Moment } from 'node_modules/moment';
import * as moment from 'moment';
@Component({
  selector: 'app-finyear',
  templateUrl: './finyear.component.html',
  styleUrls: ['./finyear.component.css']
})
export class FinYearComponent implements OnInit {
  @ViewChild('excelexport', { static: false }) excelexport!: ExcelExportComponent;
  @ViewChild('view') view!: TemplateRef<any>;
  private unsubscribe$: Subject<void> = new Subject<void>();
  pipe = new DatePipe('en-US');
  headerFinYear: PageHeader;
  entity: FinYear = new FinYear();
  selectedFinYear: FinYear = new FinYear();
  editingEntity: FinYear = new FinYear();
  finyears: any;
  finyearColumns: any[]=[];
  listView: boolean = true;
  formCaption: string = '';
  emailcheck: boolean = true;
  defaultPageSize: number;
  pageSkip: number = 0;
  pageSizes: any = [];
  defaultRowsCount: number;
  saveDisabled: boolean = false;
  company: Array<Company> = [];
  selectedCompany: any;
  isValidDate: boolean = false;
  codeCheck: boolean = true;
  codealCheck: boolean = true;
  codealStr: boolean = true;
  opened: boolean = false;
  details: any;
  constructor(
    private _finyearService: FinYearService,
    private _companyService: CompanyService,
    private _coreSaveService: CoreSaveService,
    private configService: ConfigService,
    private messageService: MessageService,
    private notification: NotificationsService,
    private dateService: DateService,
  ) {
    this.headerFinYear = this.initPageHeader();
    this.defaultPageSize = Number(this.configService.getConfigValue('defaultPageSize'));
    this.pageSizes = this.configService.getConfigValue('pageSizes');
    this.defaultRowsCount = Number(this.configService.getConfigValue('defaultRowsCount'));
 
    this.finyears = [];
    this.getAllFinYear();
  }
  ngAfterViewInit(): void {
    this.finyearColumns = [
      { field: "SlNo", title: 'SL No.', filter: false, sortable: true, width: 70 },
      { field: "FinYearName", title: 'Financial Year', filter: true, sortable: true, width: 150 },
      { field: "FinYearCode", title: 'Code', filter: true, sortable: true, width: 100 },
      { field: "StartDateStr", title: 'Start Date', filter: true, sortable: true, width: 150 },
      { field: "EndDateStr", title: 'End Date', filter: true, sortable: true, width: 150 },
      // { field: "CompanyName", title: 'Company', filter: true, sortable: true },
      { field: "Active", title: 'Active', filter: false, sortable: true, width: 100 },
      { field: "", title: '', filter: true, sortable: true, width: 60, template: this.view }
    ];

  }
  onPaginationChange(event: any) {
    if (this.defaultPageSize != event.take) {
      this.defaultPageSize = event.take;
    }
    this.pageSkip = event.skip;
    this._finyearService.getAllFinYear('', this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 0, 0).subscribe((entities: Array<FinYear>) => {
      this.finyears = {
        data: entities,
        total: entities[0] ? entities[0].TotalCount : 0
      }
      // for (let i = 0; i < this.finyears.data.length; i++) {
      //   this.finyears.data[i].StartDateStr = this.pipe.transform(this.finyears.data[i].StartDate, "dd/MM/yyyy");
      //   this.finyears.data[i].EndDateStr = this.pipe.transform(this.finyears.data[i].EndDate, "dd/MM/yyyy");
      // }
    });
  }
  getAllCompany(filter: string) {
    this._companyService.getAllCompany(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Company>) => {
      this.company = data;
    })
  }
  goToBackTab(): void {
    this.listView=true;
}
  onFilterChange(event: any): void {
    if (((event && event.filter && event.filter.filters[0] && event.filter.filters[0].filters[0]) != null)) {
      var filter = (event.filter.filters[0].filters[0].field + '|' + event.filter.filters[0].filters[0].value + ';');
      //1 for gridfilter type
      this._finyearService.getAllFinYear(filter, this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 1, 0).subscribe((finyears: Array<FinYear>) => {
        this.finyears = {
          data: finyears,
          total: finyears[0] ? finyears[0].TotalCount : 0
        }
        // for (let i = 0; i < this.finyears.data.length; i++) {
        //   this.finyears.data[i].StartDateStr = this.pipe.transform(this.finyears.data[i].StartDate, "dd/MM/yyyy");
        //   this.finyears.data[i].EndDateStr = this.pipe.transform(this.finyears.data[i].EndDate, "dd/MM/yyyy");
        // }
      });
    }
  }
  getAllFinYear() {
    this._finyearService.getAllFinYear('', Number(this.defaultPageSize), 1, 0, 0).subscribe((finyears: Array<FinYear>) => {
      this.finyears = {
        data: finyears,
        total: finyears[0] ? finyears[0].TotalCount : 0
      }
      // for (let i = 0; i < this.finyears.data.length; i++) {
      //   this.finyears.data[i].StartDateStr = this.pipe.transform(this.finyears.data[i].StartDate, "dd/MM/yyyy");
      //   this.finyears.data[i].EndDateStr = this.pipe.transform(this.finyears.data[i].EndDate, "dd/MM/yyyy");
      // }
    })
  };

  ngOnInit(): void {
    this.messageService.activeCommonMessage.pipe(takeUntil(this.unsubscribe$)).subscribe((message: ICommonMessage | null) => {
      if (message?.eventName === 'delete_read_confirmation') {
        if (message?.param.action === "FA") {
          this._finyearService.deleteFinYear(this.selectedFinYear.FinYear_Id).subscribe((entity: any) => {
            this.notification.showSuccess('Deleted Successfully');
            this.clearFinYear();
            this.getAllFinYear();
          },
          )
        }
      }
    });
  }

  initPageHeader(): PageHeader {
    let headerFinYear = new PageHeader();
    headerFinYear.PageCaption = "Financial Year";
    headerFinYear.IconClass = "bi bi-shield-shaded";
    return headerFinYear;
  }

  deleteFinYear(event: any) {
    if (event.seletedRows[0]) {
      this.selectedFinYear.FinYear_Id = event.seletedRows[0];
      var message: ICommonMessage = {
        eventName: "showDialog",
        param: {
          content: "Do you want to delete this entry ?",
          caption: "Financial Year",
          returnKey: "delete_read_confirmation"
        }
      };
      this.messageService.sendCommonMessage(message);
    }
  }

  addFinYear(event: any) {
    this.listView = false;
    this.clearFinYear();
    this.getAllCompany('');
    this.formCaption = "Add Financial Year";
  }

  editFinYear(event: any): void {
    if (event.seletedRows[0]) {
      this._finyearService.viewFinYear(event.seletedRows[0]).subscribe((finyears: Array<FinYear>) => {
        let editEnity = finyears[0] ? finyears[0] : new FinYear();
        if (editEnity) {
          this.editingEntity = editEnity;
          this.selectedCompany = { Company_Id: editEnity.Company_Id, CompanyName: editEnity.CompanyName };
          this.editingEntity.StartDate = new Date(editEnity.StartDate);
          this.editingEntity.EndDate = new Date(editEnity.EndDate);
          this.entity = { ...this.editingEntity };

          this.listView = false;
          this.formCaption = "Edit Financial Year";
          this.getAllCompany('');
          this.entity.EntityMetaData = [
            { FieldName: 'FinYearName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: ' Financial Year is required' },
            //{ FieldName: 'Company_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Company is required' },
            { FieldName: 'FinYearCode', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Code is required' },
            { FieldName: 'StartDate', FieldType: FieldType.Date, IsMandatory: true, ValidationMessage: 'Start Date is required' },
            { FieldName: 'EndDate', FieldType: FieldType.Date, IsMandatory: true, ValidationMessage: 'End Date is required' },
          ];
        }
      });
    }
  }


  save(event: any): void {
    if (parseInt(this.entity.FinYearCode) == 0) {
      this.notification.showWarning('Zero not allowed!!!');
      return
    }
    this.saveDisabled = true;
    if (this.entity.StartDate != undefined) {
      this.entity.StartDate = this.dateService.convertUTCDateToLocalDate(this.entity.StartDate);
    }
    if (this.entity.EndDate != undefined) {
      this.entity.EndDate = this.dateService.convertUTCDateToLocalDate(this.entity.EndDate);
    }

    let validations = this._coreSaveService.saveValidation(this.entity);
    if (validations.length === 0) {
      this._finyearService.checkDuplication(this.entity.FinYear_Id, this.entity.FinYearCode).subscribe((res) => {
        if (res.Success === false) {
          this.notification.showWarning('Financial Year Code already exists');
          this.saveDisabled = false;
          return
        }

        if (this.entity.StartDate != undefined && this.entity.EndDate != undefined) {
          const actualFromDate = moment(this.entity.StartDate).format('YYYY-MM-DD');
          const actualToDate = moment(this.entity.EndDate).format('YYYY-MM-DD');
          if (actualFromDate > actualToDate) {
            this.notification.showWarning('End date should be grater than start date');
            this.saveDisabled = false;
            return

          }
        }

        // const re = /^(0*[1-9]+0*)+$/;
        // const real=/^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$/;
        // const realstr=/^[a-zA-Z\s]*$/;
        // this.codeCheck = re.test(String(this.entity.FinYearCode).toString());
        // this.codealCheck = real.test(String(this.entity.FinYearCode).toString());
        // this.codealStr = realstr.test(String(this.entity.FinYearCode).toString());
        // if (this.codealCheck == false&&this.codeCheck==false && this.codealStr==false) {

        //   this.notification.showWarning("Invalid code ");
        //   this.saveDisabled = false;

        // }
        //       else 
        //       { 
        this._finyearService.saveFinYear(this.entity).subscribe(() => {
          if (this.entity.FinYear_Id == '00000000-0000-0000-0000-000000000000') {
            this.notification.showSuccess('Saved Successfully');
          }
          else {
            this.notification.showSuccess('Updated Successfully');
          }
          this.listView = true;
          this.clearFinYear();
          this.getAllFinYear();
        })
        // }
      })
    }
    else {
      this.saveDisabled = false;
    }
  }
  onPaste(event: any) {
    let Data = event.Data;
    let regexp = new RegExp('[^-_().;:,!a-zA-Z0-9/ ]');
    let pastedText = Data.getData('text');
    let test = regexp.test(pastedText);
    let trimmedText = pastedText.replace(/[^a-zA-Z0-9-()._ ]/g, '');
    (<HTMLInputElement>document.getElementById('bindingId')).value = trimmedText;
    if (test) {
      event.preventDefault();
    }
  }
  datesChange() {
    this.isValidDate = true
    if (this.entity.StartDate != undefined)
      this.entity.StartDate = this.dateService.convertToUTCDate(this.entity.StartDate);
    if (this.entity.EndDate != undefined)
      this.entity.EndDate = this.dateService.convertToUTCDate(this.entity.EndDate);
    if (this.entity.StartDate != undefined && this.entity.EndDate != undefined) {
      const actualFromDate = moment(this.entity.StartDate).format('YYYY-MM-DD');
      const actualToDate = moment(this.entity.EndDate).format('YYYY-MM-DD');
      if (actualFromDate > actualToDate) {
        ;
        //this.notification.showError('From Date must be lower than To date');
        this.isValidDate = false;
        return this.isValidDate;
      }
      // else {
      //   this.getreport();
      // }return this.isValidDate;
    }
    return this.isValidDate;
  }
  AlphabetsOnly(event: any): boolean {
    var inp = String.fromCharCode(event.keyCode);
    if (/^[a-zA-Z\s]*$/.test(inp)) {
      return true;
    } else {
      return false;
    }

  }

  gotoBack(): void {
    this.listView = true;
    this.getAllFinYear();
  }

  refreshFinYears(event: any): void {
    this.finyears = [];
    this.getAllFinYear();
  }

  clearFinYear(): void {
    this.selectedCompany = {};
    this.entity = new FinYear();
    this.saveDisabled = false;
  }

  onExcelExport() {
    this.excelexport.save()
  }

  revertChanges(): void {
    this.entity = { ...this.editingEntity };
  }

  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  AlphaNumeric(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return true;
    }
    return false;
  }
  keyPressAlpha(event: any): boolean {

    const charCode = (event.which) ? event.which : event.keyCode;

    if ((charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123) || (charCode > 47 && charCode < 58) || charCode == 32) {

      return true;

    }

    return false;

  }
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  public close() {
    this.opened = false;
  }
  public open(dataItem: any): void {
 this.entity.FinYear_Id=dataItem.FinYear_Id;
 this.details =[];
 this._finyearService.viewFinYear(this.entity.FinYear_Id).subscribe((finyears: Array<FinYear>) => {
  this.opened = true;
   this.details = finyears[0];
   });
}
}
